import type { ReactElement } from 'react';
import { useServices, useT } from '../../../app/di';
import { useResource } from '../../../shared/hooks';
import { Alert } from '../../../ui-kit/Alert/Alert';
import { Loading } from '../../../ui-kit/Loading/Loading';
import { BlogStorageFormats } from './BlogStorageFormats/BlogStorageFormats';

/** PLAN-UC-5: сводка по форматам блога в профиле; грузится, когда её раскрыли. */
export function BlogStorageFormatsConnected({ blogId }: { blogId: string }): ReactElement {
  const { api } = useServices();
  const { t, te } = useT();
  const storage = useResource(() => api.media.storage(blogId), [api, blogId]);
  if (storage.loading && !storage.data) return <Loading label={t('common.loading')} />;
  if (storage.error || !storage.data) return <Alert tone="danger">{te(storage.error ?? [])}</Alert>;
  return <BlogStorageFormats storage={storage.data} />;
}
